import * as axios from 'axios';
import { API } from '../config/config';


const postInsertBurningSignal = async function (captcha, otp, otpId, request, attachments) {
	try {
		const body = {
			request: request,
			postedFiles: attachments,
			captcha: captcha,
			otp: otp,
			otpId: otpId,
		};
		// must avoid preflight problems
		var bodyString = JSON.stringify(body);
		const params = new URLSearchParams()
		params.append("bodyText", bodyString);
		const config = {
			headers: {
				'content-type': 'application/x-www-form-urlencoded'
			}
		}
		const response = await axios.post(`${API}/BurningSignal/insertBurningSignal`, params, config);
		return response;
	} catch (err) {
		throw new Error(err)
	}
};

const postValidateBurningSignal = async function (captcha, request, attachments) {
	try {
		const body = {
			request: request,
			postedFiles: attachments,
			captcha: captcha,
		};
		// must avoid preflight problems
		var bodyString = JSON.stringify(body);
		const params = new URLSearchParams()
		params.append("bodyText", bodyString);
		const config = {
			headers: {
				'content-type': 'application/x-www-form-urlencoded'
			}
		}
		const response = await axios.post(`${API}/BurningSignal/validateForm`, params, config);
		return response;
	} catch (err) {
		throw new Error(err)
	}
};

const getProvinceList = async function () {
	try {
		const response = await axios.get(`${API}/BurningSignal/GetProvinceList`);
		return response;
	} catch (err) {
		throw new Error(err)
	}
};

const getDistrictsList = async function (province) {
	try {
		const response = await axios.get(`${API}/BurningSignal/GetDistrictsList?province=${province}`);
		return response;
	} catch (err) {
		throw new Error(err)
	}
};

const getPairPeriod = async function () {
	try {
		const response = await axios.get(`${API}/BurningSignal/GetPairPeriod`);
		return response;
	} catch (err) {
		throw new Error(err)
	}
}

const getDivietoDL692023Period = async function () {
	try {
		const response = await axios.get(`${API}/BurningSignal/GetDivietoDL692023Period`);
		return response;
	} catch (err) {
		throw new Error(err)
	}
}

const getDivietoEstivoDL692023Period = async function () {
	try {
		const response = await axios.get(`${API}/BurningSignal/GetDivietoEstivoDL692023Period`);
		return response;
	} catch (err) {
		throw new Error(err)
	}
}

const getCurrentState = async function () {
	try {
		const response = await axios.get(`${API}/BurningSignal/GetCurrentState`);
		return response;
	} catch (err) {
		throw new Error(err)
	}
}

export const burningSignalService = {
	postInsertBurningSignal,
	postValidateBurningSignal,
	getProvinceList,
	getDistrictsList,
	getPairPeriod,
	getDivietoDL692023Period,
	getDivietoEstivoDL692023Period,
	getCurrentState
};
